import { buildPollingState, PollingState } from '@Stores/index';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: PollingState = buildPollingState({
  entity: [],
}) satisfies PollingState as PollingState;

const arsenalArmiesSlice = createSlice({
  name: 'polling',
  initialState,
  reducers: {
    register(state: PollingState, action: PayloadAction<string>) {
      state.entity!.push(action.payload);
    },
    unregister(state: PollingState, action: PayloadAction<string>) {
      state.entity = state.entity!.filter((item) => item !== action.payload);
    },
  },
});

export default arsenalArmiesSlice;
